// import

import {styled} from 'goober';
import type {ReactChildren} from 'react';

import {isStr} from 'libs/rambo';
import {Image} from 'modules/Image';
import {Type} from 'modules/Type';

// types

type Props = {
  icon: JSX.Element;
  type: string;
  title: string;
  image?: string;
  children: ReactChildren | string;
  color: string;
};

// component

export function Header(props: Props) {
  const {icon, type, image, title, children, color} = props;

  return (
    <Styled style={{'--color': `var(--${color})`}}>
      <aside>{icon}&thinsp;{type}</aside>

      <h1>
        {image ? (
          <div className="image">
            <Image
              alt={`Image of ${title}`}
              height={16 * 9}
              layout="intrinsic"
              src={image}
              width={16 * 9}
            />
          </div>
        ) : null}
        <div className="text">{title}</div>
      </h1>

      {isStr(children) ? (
        <Type className="body">{children}</Type>
      ) : (
        <div className="body">{children}</div>
      )}
    </Styled>
  );
}

// styles

const Styled = styled('section')`
  margin-bottom: 4.5rem;

  > aside {
    font-size: 1rem;
    font-weight: 300;

    svg {
      position: relative;
      top: 0.125rem;
      width: 1rem;
      color: var(--color);
    }
  }

  > h1 {
    margin: 0;
    font-family: var(--font-head);
    font-weight: 300;
    font-size: 4rem;
    line-height: 4rem;
    display: flex;
    gap: 0.5rem;

    > * { flex: 1 1 auto; }

    .image {
      flex: 1 1 auto;
      margin-top: 0.25rem;
      max-width: 3.5rem;
      max-height: 3.5rem;
      border-radius: 100rem;
      overflow: hidden;
    }
  }

  > div {
    position: relative;
    margin-top: 0.5rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding: 0.5rem 3rem 0.5rem 1.5rem;

    &::before {
      content: "";
      background-color: var(--color);
      width: 0.5rem;
      border-radius: 0.5rem;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0.25rem;
    }
  }
`;
